import SelectedReviews from "@/components/common/SelectedReviews";
import styled from "@emotion/styled";
import { colors } from "goi_common";
import { ParlorDetailProps } from "@/types/parlor";
import ParlorDetailConsult from "../ParlorDetailConsult";
import Amenity from "./Amenity";
import Map from "./Map";

function AmenityInfoTabPanel({ parlor }: { parlor: ParlorDetailProps }) {
  return (
    <>
      <AmenityInfoTabPanelRoot>
        <SelectedReviews path="parlor_detail" />
        <h3 className="button2">위치</h3>
        <div style={{ marginTop: "12px" }} />
        <Map parlor={parlor} />
        <div style={{ marginTop: "44px" }} />
        <h3 className="button2">시설 정보</h3>
        <div style={{ marginTop: "14px" }} />
        <Amenity amenities={parlor.amenities} />
      </AmenityInfoTabPanelRoot>
      <div style={{ backgroundColor: colors.gray50, height: "10px" }} />
      <ParlorDetailConsult />
    </>
  );
}

const AmenityInfoTabPanelRoot = styled.div`
  padding: 19px 19px 40px; ;
`;

export default AmenityInfoTabPanel;
